<template>
  <div class="guest-profile-card">
    <div class="avatar-container">
      <AvatarCircle size="200" :isGuest="true" />
    </div>
    <div class="group-box" :class="{'compact': !$store.state.onMobile}">
      <span class="group-box-header">Статус: Гость</span>
      <hr>
      <div>
        Зарегистрируйтесь чтобы получить больше возможностей, а именно:
      </div>
      <div class="caps-container">
        <div class="cap">
          <div>Гибкая настройка и персонализация интересов</div>
          <sub><i>(календарь событий будет подстроен под Ваши инетересы)</i></sub>
        </div>
        <div class="cap">
          <div>Создавать свои мероприятия</div>
          <sub><i>(совместное планирование с друзьями и близкими)</i></sub>
        </div>
        <div class="cap">Приглашать друзей</div>
        <div class="cap">Видеть участников мероприятия</div>
        <div class="cap">
          <div>Уникальный функционал для студентов и преподавателей</div>
          <sub><i>(отображение расписание учебных занятий в календаре)</i></sub>
        </div>
        <div class="cap">
          <div>Получать полезные уведомления</div>
          <sub><i>(приглашения на мероприятия, новости, изменения в расписании заниятий)</i></sub>
        </div>
      </div>
      <div>
        <span>Всё это и многое другое станет доступным в единой эко системе </span>
        <span class="link">{{$host.apptitle}}. </span>
        <span>Мы постоянно развиваем нашу систему, расширяя возможности.</span>
      </div>
      <div class="register-link">
        <a href="/register" class="link"><u>Зарегистроваться</u></a>
      </div>
    </div>
    
    <div class="group-box" :class="{'compact': !$store.state.onMobile}">
      <span class="group-box-header">Оформление</span>
      <hr>
      <VisualAppearanceOptions />
    </div>
  </div>
</template>

<script>
import VisualAppearanceOptions from '@/components/VisualAppearanceOptions.vue';

export default {
  name: "GuestProfileCard",
  components: {
    VisualAppearanceOptions
  },
  data: function () {
    return {
    }
  },
  computed: {
    linkTextColor() {
      // Получаем значение --linkTextColor из :root или конкретного элемента
      const rootStyles = getComputedStyle(document.documentElement);
      return rootStyles.getPropertyValue('--linkTextColor').trim();
    },
  },
  methods: {
  }
}
</script>

<style src='@/assets/css/user-profile.css'>
</style>

<style scoped>
.caps-container {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.caps-container .cap {
  margin-top: 0.5rem;
  display: list-item;
  margin-left: 1rem;
}

.caps-container .cap sub {
  display: block;
}
.register-link {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  font-size: 1.5em;
}
.avatar-container {
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  width: max-content;
}
</style>